import { useState } from "react";
// Hooks
import { useCheckAPI } from "../../hooks/useCheckAPI";
import { useUrlFilterState } from "../../hooks/useUrlFilterState";
// API State Import
import { useContractList } from "../../state/contractListState";
// Component imports
import { ContractListHeader } from "../../components/ContractListHeader";
import { ContractTableFilterBar } from "./ContractTableFilterBar";
import { ContractTable } from "./ContractTable";

export function ContractList() {
  const [contractFilter, setContractFilter] = useUrlFilterState({
    status: "All",
    search: "",
    page: 1,
  });

  const [contracts, setContracts] = useState({
    contract: [],
    filter: {},
    paging: {},
  });

  // Fetch the contracts list and pass in the filter values
  const { isPending, isError, data, error, isFetching, isSuccess } =
    useContractList(contractFilter);

  // Success Function
  const successFunc = () => {
    setContracts(data.data.data.data.list);
  };

  // Error Function
  const errorFunc = () =>
    console.warn(`Error: ${data.data.status}: ${data.data.statusText}`);

  // Hook to check the BC API for errors
  useCheckAPI(isSuccess, data, data?.data?.status, successFunc, errorFunc);

  return (
    <>
      <ContractListHeader />
      <ContractTableFilterBar
        contractFilter={contractFilter}
        setContractFilter={setContractFilter}
      />
      {isError && <span>Error: {error.message}</span>}
      <ContractTable
        contracts={contracts}
        loading={isFetching}
        contractFilter={contractFilter}
        setContractFilter={setContractFilter}
      />
    </>
  );
}
